import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Log } from "ng2-logger";
import { AuthenticationService } from "@app/authentication/services/authentication.service";
import { ConfirmationModalComponent } from "@app/shared/components";
import { Router } from "@angular/router";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-register-form',
    templateUrl: './register-form.component.html',
    styleUrls: ['./register-form.component.scss']
})
export class RegisterFormComponent implements OnInit {
    _logger = Log.create(RegisterFormComponent.name);
    @ViewChild(ConfirmationModalComponent, {static: true}) confirmationModal: ConfirmationModalComponent;

    registerFormStepOne: UntypedFormGroup;
    registerFormStepTwo: UntypedFormGroup;
    canContinue: boolean;
    showValidations: boolean;
    passwordMatch = false;

    // Used to validate email since Validators.email returns error if the field is empty
    validateEmail = "[a-zA-Z0-9._-]+[@]+[a-zA-Z0-9-]+[.]+[a-zA-Z]{2,6}";

    constructor(
        private router: Router,
        private formBuilder: UntypedFormBuilder,
        private authService: AuthenticationService,
        private translate: TranslateService,
        private toastr: ToastsManager) {

        this.registerFormStepOne = this.formBuilder.group({
            'username': ['', Validators.required],
            'firstName': ['', Validators.required],
            'lastName': ['', Validators.required],
            'registerReason': ['', Validators.required]
        });

        this.registerFormStepTwo = this.formBuilder.group({
            'email': [null, Validators.pattern(this.validateEmail)],
            'password': ['', Validators.required],
            'passwordConfirmation': ['', Validators.required],

        })
    }

    ngOnInit() {
        this.onFormChange();
        this.onSecondFormChange();
    }

    onConfirmRegister(event) {

        const formData = Object.assign({},
            this.registerFormStepOne.value,
            this.registerFormStepTwo.value,
            {
                boschId: event.boschId
            });

        this._logger.info('onConfirmRegister:: Attempting to register user with data ', formData);
        this.authService.register(formData).subscribe(
            (data: any) => {
                this._logger.info('handleRegister:: API returned data: ', data);
                this.toastr.info(this.translate.instant('auth.toasts.registerSuccess'));
                this.router.navigate(['/auth/login']);
                this.confirmationModal.close();
            },
            (error: any) => {
                this._logger.error('handleRegister:: API returned error: ', error);
                this.confirmationModal.close();
            });
    }

    onRegister() {
        if ((!this.validatePasswordMatch() && !this.registerFormStepTwo.valid)
            || !this.registerFormStepTwo.valid
            || !this.validatePasswordMatch()) {
            this.showValidations = true;
            return;
        }
        this.confirmationModal.open();
    }

    /**
     *  Displays the errors of the First Form if it is invalid, on Submit
     * */
    registerCanContinue() {
        if (!this.registerFormStepOne.valid) {
            this.showValidations = true;
        }
    }

    /**
     *  Checking if the First Form Status changes and enables the "NEXT" button if it is valid
     * */
    private onFormChange(): void {
        this.registerFormStepOne.statusChanges.subscribe(() => {
            this.canContinue = this.registerFormStepOne.valid;
            this.showValidations = false;
        })
    }

    /**
     *  Checking if the Second Form values changes and removes the password errors
     * */
    private onSecondFormChange(): void {
        this.registerFormStepTwo.valueChanges.subscribe(() => {
            if (this.passwordMatch && this.registerFormStepTwo.value.password !== '') {
                this.passwordMatch = false;
            }
        })
    }

    private validatePasswordMatch() {
        const password = this.registerFormStepTwo.value.password;
        const confirmPassword = this.registerFormStepTwo.value.passwordConfirmation;

        if (password !== confirmPassword) {
            this.passwordMatch = true;
            this.registerFormStepTwo.patchValue({
                password: '',
                confirmPassword: ''
            });
            return;
        } else {
            return true;
        }
    }

}
